<h2 mat-dialog-title>Add Teammate</h2>
<mat-dialog-content class="mat-typography">
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="addTeamMember()" [formGroup]="dataForm">
        <div class="form-group">
          <label>Name </label>
          <input class="form-control" placeholder="Enter Name" formControlName="userName"
                 [ngClass]="{'is-invalid': submitted && dataForm.controls.userName.errors}">
          <div *ngIf="form.userName.touched && form.userName.errors" class="invalid-feedback">
            <span *ngIf="form.userName.errors.required">Name is mandatory.</span>
          </div>
        </div>

        <div class="form-group">
          <label>Phone Number </label>
          <input class="form-control" placeholder="Enter phone number" formControlName="userPhoneNumber"
                 [ngClass]="{'is-invalid': submitted && dataForm.controls.userPhoneNumber.errors}" minlength="10"
                 onkeyup="this.value=this.value.replace(/[^\d]/,'')">
          <div *ngIf="form.userPhoneNumber.touched && form.userPhoneNumber.errors" class="invalid-feedback">
            <span *ngIf="form.userPhoneNumber.errors.required">Phone Number is mandatory.</span>
            <span *ngIf="form.userPhoneNumber.errors.minlength">Phone number must be 10 characters.</span>
          </div>
        </div>

        <div class="form-group">
          <label>Email </label>
          <input type="email" class="form-control" placeholder="Enter email" formControlName="userEmail"
                 [ngClass]="{'is-invalid': submitted && dataForm.controls.userEmail.errors}">
          <h6 class="text-small text-muted">NOTE: Email will be used to login the user</h6>
          <div *ngIf="form.userEmail.touched && form.userEmail.errors" class="invalid-feedback">
            <span *ngIf="form.userEmail.errors.required">Email is mandatory.</span>
          </div>
        </div>
        <div class="row d-flex justify-content-between align-text-bottom ml-1 mr-1">
          <div class="form-check mb-3 d-flex">
            <input type="radio"
                   name="type"
                   id="type1"
                   value="Service Center"
                   formControlName="type"
                   class="form-check-input"><label
            for="type1" class="form-check-label"> Service Center </label>
          </div>
          <div class="form-check mb-3 d-flex">
            <input type="radio"
                   name="type"
                   id="type2"
                   value="Fleet"
                   formControlName="type"
                   class="form-check-input"><label
            for="type2" class="form-check-label"> Fleet </label>
          </div>
        </div>
        <div class="form-group">
          <label>Branch Name </label>
          <input class="form-control" placeholder="Enter Branch Name" formControlName="branchName"
                 [ngClass]="{'is-invalid': submitted && dataForm.controls.branchName.errors}">
          <div *ngIf="form.branchName.touched && form.branchName.errors" class="invalid-feedback">
            <span *ngIf="form.branchName.errors.required">Branch Name is mandatory.</span>
          </div>
        </div>
        <mat-form-field  class="col-12 p-0 m-0">
          <mat-label>Role</mat-label>
          <mat-select formControlName="roleId">
            <mat-option style="z-index: 999999" *ngFor="let role of roles"
                        [value]="role.roleId">{{role.roleName}}</mat-option>
          </mat-select>
        </mat-form-field>


        <div class="d-flex justify-content-center">
          <button type="button" class="btn btn-danger ml-1 mr-2" (click)="dialogRef.close()">Cancel</button>
          <button type="submit" class="btn btn-success">Save</button>
        </div>
      </form>
    </div>
  </div>

</mat-dialog-content>
